/* eslint-disable */
import React from "react";
import { useTranslation } from "react-i18next";
import FormInput from "../../../controls/FormInput";
const FilterBox = ({ currentFilterValue, setFilter }) => {
    const [t] = useTranslation("common");
    const applyFilter = React.useCallback((value) => setFilter(value), [setFilter]);
    return (React.createElement(FormInput, { type: "search", id: "file-based-load-order-filter", className: "file-based-load-order-filter", value: currentFilterValue, placeholder: t("Search for a specific load order entry..."), onChange: applyFilter, debounceTimer: 100, clearable: true }));
};
export default FilterBox;
